import React from 'react'
import PropTypes from 'prop-types'

const spotifyIframe = (podcastId) =>
  `<iframe src="https://open.spotify.com/embed/episode/${podcastId}?theme=0" width="100%" height="152" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>`

const PodcastWidget = ({ spotifyPodcastEpisodeId }) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: spotifyIframe(spotifyPodcastEpisodeId)
      }}
    />
  )
}

PodcastWidget.propTypes = {
  spotifyPodcastEpisodeId: PropTypes.string
}

export default PodcastWidget
